import create from 'zustand'

import { generalStoreCreator } from './general.store'
import { layoutStoreCreator } from './layout.store'
import { galleryStoreCreator } from './gallery.store'

export const useStore = create((set) => ({
  ...generalStoreCreator(set),
  ...layoutStoreCreator(set),
  ...galleryStoreCreator(set)
}))
